import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import fa from './locales/fa.json';
import en from './locales/en.json';
import ar from './locales/ar.json';

const resources = {
  fa: { translation: fa },
  en: { translation: en },
  ar: { translation: ar },
};

const LANG_STORAGE_KEY = 'flasher_lang';
const LEGACY_LANG_STORAGE_KEY = 'ojet_lang';

try {
  const legacy = localStorage.getItem(LEGACY_LANG_STORAGE_KEY);
  const next = localStorage.getItem(LANG_STORAGE_KEY);
  if (legacy && !next && ['fa', 'en', 'ar'].includes(legacy)) {
    localStorage.setItem(LANG_STORAGE_KEY, legacy);
  }
} catch {
  /* ignore */
}

// RTL languages
const RTL_LANGS = ['fa', 'ar'];

export const isRTL = (lang) => RTL_LANGS.includes(lang || i18n.language);
export const setDocumentDirection = (lang) => {
  const dir = isRTL(lang) ? 'rtl' : 'ltr';
  document.documentElement.dir = dir;
  document.documentElement.lang = lang === 'fa' ? 'fa-IR' : lang === 'ar' ? 'ar' : 'en';
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fa',
    supportedLngs: ['fa', 'en', 'ar'],
    load: 'languageOnly',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: LANG_STORAGE_KEY,
    },
    react: {
      useSuspense: false,
    },
  });

i18n.on('languageChanged', (lng) => {
  const code = lng?.split('-')[0];
  setDocumentDirection(code);
  if (code && ['fa', 'en', 'ar'].includes(code)) {
    localStorage.setItem(LANG_STORAGE_KEY, code);
  }
});

i18n.on('initialized', () => {
  const lng = i18n.language?.split('-')[0];
  const supported = ['fa', 'en', 'ar'];
  setDocumentDirection(supported.includes(lng) ? lng : 'fa');
});

export default i18n;
